import { Button } from "@/components/Core/Button";
import PhoneNumberInput from "@/components/Core/CustomPhoneInput";
import { Input } from "@/components/Core/Input";
import { camelCaseToLower, RenderToast } from "@/helper/HelperFunction";
import { useState } from "react";
import { parsePhoneNumber } from "react-phone-number-input";
import ModalSkeleton from "../ModalSkeleton";
import classes from "./AddEditWareHouseModal.module.css";
import Maps from "@/components/Core/MapAndPlaces";
import { useSelector } from "react-redux";

const AddEditWareHouseModal = ({
  show,
  setShow,
  selectedItem,
  handleClick,
  modalLoading,
}) => {
  const { user } = useSelector((state) => state.authReducer);

  // Determine filter state name - expects state abbreviation like "GA", "CA", etc.
  // Update this to use the correct field from your state object (e.g., code, abbreviation, key)
  const filterStateName = user?.defaultState?.fullName || null;

  const [name, setName] = useState(selectedItem?.name || "");
  const [address1, setAddress1] = useState(selectedItem?.address1 || "");
  const [addrPhone, setAddrPhone] = useState(selectedItem?.addrPhone || "");
  const [country, setCountry] = useState(selectedItem?.country || "");
  const [city, setCity] = useState(selectedItem?.city || "");
  const [zip, setZip] = useState(selectedItem?.zip || "");
  const [coordinates, setCoordinates] = useState(
    selectedItem?.coordinates
      ? { lng: selectedItem?.coordinates[0], lat: selectedItem?.coordinates[1] }
      : null
  );
  const [locationAddress, setLocationAddress] = useState(
    selectedItem?.address || ""
  );
  const [locationNo, setLocationNo] = useState(selectedItem?.locationNo || "");

  const handleSubmit = () => {
    const params = {
      ...(selectedItem && { warehouseId: selectedItem?._id }),
      name,
      address: locationAddress,
      country,
      city,
      locationNo,
      zip,
      addrPhone,
      address1,
    };
    for (const key in params) {
      if (key === "coordinates") {
        if (!params[key] || !params[key].lat || !params[key].lng) {
          return RenderToast({
            type: "error",
            message: `${camelCaseToLower(key)} is required`,
          });
        }
      } else if (!params[key]) {
        return RenderToast({
          type: "error",
          message: `${camelCaseToLower(key)} is required`,
        });
      }
      if (key === "addrPhone") {
        const phone = parsePhoneNumber(params[key]);

        if (!phone || phone.country !== "US") {
          return RenderToast({
            type: "error",
            message: "Please enter valid US phone number",
          });
        }
      }
    }
    if (!coordinates) {
      return RenderToast({
        type: "error",
        message: "Please select a location",
      });
    }
    params.location = [coordinates?.lng, coordinates?.lat];

    handleClick(params);
  };
  return (
    <>
      <ModalSkeleton
        show={show}
        setShow={setShow}
        header={selectedItem ? "Update Warehouse" : "Add Warehouse"}
        width="650px"
      >
        <div className={classes.mainWrapper}>
          <Input
            label="Warehouse Name"
            value={name}
            setter={setName}
            placeholder="Enter Warehouse Name"
          />
          <Input
            label="Location No"
            value={locationNo}
            setter={setLocationNo}
            placeholder="Enter Location No"
          />

          <div className={classes.fullWidth}>
            <Maps
              type="places"
              label="Location"
              placeholder="Enter Location"
              address={locationAddress}
              setAddress={setLocationAddress}
              setCoordinates={setCoordinates}
              filterStateName={filterStateName}
              setPlaceDetail={(e) => {
                setCountry(e?.country);
                setCity(e?.city);
                setZip(e?.zipcode);
              }}
            />
          </div>
          <Input
            label="Country"
            value={country}
            setter={setCountry}
            placeholder="Enter Country"
          />
          <Input
            label="City"
            value={city}
            setter={setCity}
            placeholder="Enter City"
          />
          <Input
            label="Zip"
            value={zip}
            setter={setZip}
            placeholder="Enter Zip"
          />
          <PhoneNumberInput
            label="Phone"
            value={addrPhone}
            setter={setAddrPhone}
            placeholder="Enter Address Phone"
          />
          <div className={classes.addressWrapper}>
            <Input
              label="Address"
              value={address1}
              setter={setAddress1}
              placeholder="Enter Address"
            />
          </div>
        </div>
        <div className={classes.buttonsContainer}>
          <Button
            label="Cancel"
            onClick={() => setShow(false)}
            disabled={modalLoading}
          />
          <Button
            label={modalLoading ? "Saving..." : "Save"}
            onClick={handleSubmit}
            disabled={modalLoading}
            variant="secondary"
          />
        </div>
      </ModalSkeleton>
    </>
  );
};

export default AddEditWareHouseModal;
